export const L = {
  app: {
    name: 'HomeStock',
    tagline: 'Controle seu estoque doméstico',
  },

  nav: {
    items: 'Itens',
    shopping: 'Compras',
    history: 'Histórico',
    premium: 'Premium',
    about: 'Sobre',
    admin: 'Admin',
    notifications: 'Avisos',
    menu: 'Menu',
  },

  install: {
    title: 'Instalar HomeStock',
    desc: 'Acesso rápido na tela inicial',
    install: 'Instalar',
  },

  items: {
    title: 'Meus Itens',
    search: 'Buscar item...',
    addFirst: 'Adicione seus primeiros itens',
    addFirstDesc: 'Cadastre os produtos que você controla em casa.',
    notFound: 'Nenhum item encontrado',
    notFoundDesc: 'Tente outro termo de busca.',
    addButton: 'Adicionar item',
    buyLabel: 'Comprar',
    atHomeLabel: 'Em casa',
    lastPrice: 'Último',
    edit: 'Editar',
    history: 'Histórico',
    delete: 'Excluir',
    selectMultiple: 'Selecionar vários',
    exitBatch: 'Sair do modo lote',
    itemSelected: 'item selecionado',
    itemsSelected: 'itens selecionados',
    markToBuy: 'Marcar para comprar',
    unmark: 'Desmarcar',
    renameList: 'Renomear lista',
    listNamePlaceholder: 'Nome da lista',
    save: 'Salvar',
    saving: 'Salvando...',
    close: 'Fechar',
    confirm: 'Confirmar',
    qtyToBuy: 'Quantidade a comprar',
    qtyPlaceholder: 'ex: 2 unidades, 1kg',
    frozenTitle: 'Lista congelada',
    frozenDesc: 'Seu plano Premium expirou. Para editar itens, renove sua assinatura.',
    seePremium: 'Ver planos Premium',
    noListTitle: 'Bem-vindo ao HomeStock!',
    noListDesc: 'Crie sua primeira lista para começar a controlar seu estoque doméstico.',
    createList: 'Criar minha lista',
    removeFromCart: 'Remover da lista de compras',
    addToCart: 'Adicionar à lista de compras',
    renameLabel: 'Renomear lista',
    batchQtyPlaceholder: 'Qtd (ex: 2un)',
  },

  settings: {
    title: 'Configurações',
    accountSection: 'Conta',
    email: 'E-mail',
    installApp: 'Instalar como app',
    installAppDesc: 'Adicionar na tela inicial',
    installButton: 'Instalar',
    signOut: 'Sair da conta',
    signOutShort: 'Sair',
    signingOut: 'Saindo...',
    signOutTitle: 'Sair da conta',
    signOutMsg: 'Deseja sair da conta?',
    householdSection: 'Lista / Família',
    listName: 'Nome da lista',
    ownerLabel: 'Dono',
    guestLabel: 'Convidado',
    removeButton: 'Remover',
    collaboratorsSection: 'Colaboradores',
    manageCollab: 'Gerenciar colaboradores',
    manageCollabDesc: 'Convide pessoas para compartilhar a lista',
    open: 'Abrir',
    shareSection: 'Compartilhar lista',
    shareDesc: 'Gere um link para convidar membros para sua lista.',
    generateInvite: 'Gerar link de convite',
    newInvite: 'Gerar novo convite',
    shareWhatsapp: 'Compartilhar via WhatsApp',
    shareUpgradeLabel: 'Compartilhamento',
    shareUpgradeValue: 'Disponível no plano Premium',
    shareUpgradeButton: 'Upgrade',
    notificationsSection: 'Notificações',
    inAppNotifs: 'Notificações in-app',
    inAppNotifsDesc: 'Lembretes de expiração do plano',
    adminSection: 'Administração',
    adminPanel: 'Painel Admin',
    access: 'Acessar',
    removeMemberTitle: 'Remover membro',
    removeMemberFrom: (name: string) => `Remover ${name} da lista?`,
  },

  premium: {
    title: 'Premium',
    active: 'Plano Premium ativo',
    validUntil: (date: string) => `Válido até ${date}`,
    free: 'Plano Gratuito',
    upgradeTitle: 'Upgrade para Premium',
    benefits: [
      'Compartilhe a lista com a família',
      'Múltiplas listas de compras',
      'Histórico completo de preços',
    ],
    subscribeTo: (price: string) => `Assinar por ${price}`,
    defaultPrice: 'R$ 15,00/ano',
  },

  about: {
    title: 'Sobre',
  },

  errors: {
    deleteItem: 'Erro ao excluir item.',
    updateItem: 'Erro ao atualizar item.',
    inviteGenerate: 'Erro ao gerar convite.',
    inviteCopied: 'Link de convite copiado!',
    signOut: 'Erro ao sair.',
    removeMember: 'Erro ao remover membro.',
    renameError: 'Erro ao renomear lista.',
    renameSuccess: 'Nome da lista atualizado!',
    notifOn: 'Notificações ativadas.',
    notifOff: 'Notificações desativadas.',
    itemsUpdate: 'Itens atualizados.',
    itemsUpdateError: 'Erro ao atualizar itens.',
  },
};
